export const GENDER_M = 'GENDER_M'
export const GENDER_F = 'GENDER_F'
